export function toBoolean(value?: string | boolean): boolean {
  if (String(value).toLowerCase() === 'true' || String(value).toLowerCase() === 't') {
    return true;
  } else {
    return false;
  }
}
